module.exports = "pegasus_template/assets/blocks/column-15-tech.png";